import { selectShu2SearchCondition } from '../../utils/shu';
import { ShuOption } from '../shu';
import { resolveUnitDataListFetchHalls } from '../unitDataList/resolveUnitDataListFetchHalls';
import { DataDai, UnitDataListFormConditions } from './types';

/**
 * メインテーブル・ハイライト平均行で共通の /data/dai 検索条件を組み立てる。
 * searchCondition を正とし、種別・店舗スライダーの選択を反映する。
 */
export const buildDataDaiFetchParams = (
  searchCondition: UnitDataListFormConditions,
  currentShu: ShuOption,
  currentHalls: string[]
): DataDai['setting'] => {
  const { selectDateUnit, ...params } = searchCondition;
  return {
    ...params,
    ...selectShu2SearchCondition(currentShu),
    areas: searchCondition.areas ?? [],
    halls: resolveUnitDataListFetchHalls(currentHalls, searchCondition.halls),
  };
};
